import { useEffect, useRef } from "react";
import { useNotifyStatus } from "contexts/status";
import { useAppSelector, type RootState } from "src/store/store";
import { useTranslation } from "react-i18next";

const ERROR_THROTTLE_MS = 30000;

export const ErrorNotificationMonitor = () => {
  const { t } = useTranslation();
  const notifyStatus = useNotifyStatus();
  const lastNotificationTimeRef = useRef(0);
  const lastErrorTimestamp = useAppSelector(
    (state: RootState) => state.connection.lastErrorTimestamp
  );

  useEffect(() => {
    if (lastErrorTimestamp) {
      const now = Date.now();
      if (now - lastNotificationTimeRef.current > ERROR_THROTTLE_MS) {
        lastNotificationTimeRef.current = now;
        notifyStatus({
          type: "error",
          text: t("connectionIssuesDetected"),
        });
      }
    }
  }, [lastErrorTimestamp, notifyStatus, t]);

  return null;
};
